import { CECustomLogicRequirementBase } from './ce-custom-logic-requirement-base'


export class CECustomLogicRequirement extends CECustomLogicRequirementBase {

}